let tabIndex = 0;

function getTabIndex() { tabIndex++; return tabIndex };

export default getTabIndex;
export { getTabIndex };